/* Beonixe: compact free-shipping box with progress bar in the cart drawer. Threshold: Theme settings > Cart > Free shipping amount. */
if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;
      const threshold = Math.round(Number(this.getAttribute('data-free-shipping')) * rate);
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      if ( !threshold ) { this.innerHTML = ''; return; }

      const remaining = threshold - cartTotal;
      const pct = Math.max(0, Math.min(100, Math.round((cartTotal / threshold) * 100)));
      const unlocked = remaining <= 0;
      const money = '$' + (Math.abs(remaining) / 100).toFixed(2);

      const title = unlocked
        ? '&#127881; You got FREE shipping!'
        : '&#128666; You\'re <span style="color:#ffd700">' + money + '</span> away from FREE shipping';

      this.innerHTML =
        '<div role="status" aria-live="polite" style="margin:0 0 12px;padding:10px 14px;border-radius:12px;background:' + (unlocked ? '#1f5c2e' : '#2e1717') + ';color:#f6ede4;">' +
          '<div style="font-size:15px;font-weight:700;line-height:1.25;text-align:center;">' + title + '</div>' +
          '<div aria-hidden="true" style="margin-top:8px;height:8px;border-radius:99px;background:rgba(246,237,228,.25);overflow:hidden;">' +
            '<div style="height:100%;width:' + pct + '%;border-radius:99px;background:' + (unlocked ? '#7ddc8a' : '#ffd700') + ';transition:width .4s ease;"></div>' +
          '</div>' +
        '</div>';
    }
  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
